"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tavullia": {
    "f16f8a01": [{
      "hkey": "a85a21b8",
      "slug": "rio-salso-case-bernardi",
      "name": "Rio Salso-Case Bernardi",
      "primary": true,
      "skipSearch": false
    }],
    "case-bernardi": [{
      "hkey": "a85a21b8",
      "slug": "rio-salso-case-bernardi",
      "name": "Rio Salso-Case Bernardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tavullia"
    }],
    "886c8f7a": [{
      "hkey": "a85a21b8",
      "slug": "rio-salso-case-bernardi",
      "name": "Rio Salso-Case Bernardi",
      "primary": true,
      "skipSearch": false
    }],
    "rio-salso": [{
      "hkey": "a85a21b8",
      "slug": "rio-salso-case-bernardi",
      "name": "Rio Salso-Case Bernardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;